import React from 'react';
// import Carousel from '../carousel/carousel';

class Mantra_22b_Canvas extends React.Component {
    constructor() {
        super();
        this.state = {

        }
    }

    render() {

        const { message, yourFriendName, index } = this.props
        return (
            <section className="canvas_section mantra22b_canvas setdiv_canvas" id={"canvas_generate_" + this.props.module_name} >
                <div className="m22_prev_wrp">
                    <div className="m22_prev_wrp_overlay">
                        <p className="m22_prev_ov_txt">{message}</p>
                    </div>
                    {/* <img src="/assets/img/m22_img/m22_a_circle1.png" className="m22b_img active" /> */}
                    <img src={"/assets/img/m22_img/m22_a_circle" + (index + 1) + ".png"} className="m22b_img active" />
                </div>
                <h4><span>To, </span>{yourFriendName}</h4>
            </section>
        )
    }
}

export default Mantra_22b_Canvas;